








import {Vue, Component} from 'vue-property-decorator';
import {addClass, removeClass} from '@/utils/classUtils';

@Component
export default class PopupView extends Vue {
  private mounted() {
    addClass(document.body, 'popup');
  }

  private beforeDestroy() {
    removeClass(document.body, 'popup');
  }
}
